<template>
<v-card-text>

  <v-select :items="fields" :label="`${$t('Pole formularza')}`" item-text="name" item-value="id" required @change="update({depend_field_id: $event})">
  </v-select>
  <v-select :items="relatedGroupTypes" :label="`${$t('related.group_type')}`" item-text="name" item-value="id" required @change="update({group_type_id: $event})">
  </v-select>
  <v-switch :label="`${$t('schema.builder.inputs.options.required')}`" :input-value="options.required" @change="update({required: $event})"></v-switch>
  <v-switch :label="`${$t('schema.builder.inputs.options.scan-only')}`" :input-value="options.scanOnly" @change="update({scanOnly: $event})"></v-switch>
</v-card-text>
</template>
<script>
import options from "@/mixins/options"
import FieldReader from '@/plugins/FieldReader'
import fieldType from '@/enums/fieldType'

export default {
  name: "date-options",
  mixins: [options],
  data() {
    return {
      reader: new FieldReader()
    }
  },
  computed: {
    relatedGroupTypes() {
      return this.$store.state.relatedGroupTypes
    },
    fields() {
      if (this.context != undefined) {
        let fields = this.context.getFields()
        return this.reader.getFlattenedFields(fields)
      }
    }
  },
  created() {
    //this.reader.addExcludedFieldType(fieldType.DEPEND)
    this.reader.addExcludedFieldType(fieldType.TABLE)
    this.reader.addExcludedFieldType(fieldType.PHOTO)
    this.reader.addExcludedFieldType(fieldType.SIGNATURE)
    this.reader.addExcludedFieldType(fieldType.ARCHIVE)
    this.loadRelatedGroupTypes()
  },
  methods: {
    loadRelatedGroupTypes() {
      if (this.relatedGroupTypes.length == 0)
        return this.$store.dispatch('loadRelatedGroupTypes')
    }
  },
}
</script>
<style>
</style>
